import CategoryAlertsTable from "./alertsTable";
import AlertSidePanel from "./alertSidePanel";
import ComplianceTable from "./complianceTable";

export interface ISortData {
  field: string;
  order: number;
}

export interface ShowMoreState {
  [key: string]: boolean;
}

/**
 * This component tries to separate out the related components
 * that do not have to do with the Redux list of alerts and 
 * those that do, this is so that only the affected components
 * are refreshed when data is added or changed.
 * @returns 
 */
export const Alerts: () => JSX.Element = () => {
  return (
    <div className="h-full overflow-hidden" style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      
      {/* All data tied to the Redux list of alerts */}
      <CategoryAlertsTable />
    </div>
  );
};